import { GraphQLRequestClient } from '@sitecore-jss/sitecore-jss-nextjs/graphql';
import graphqlClientFactory from 'lib/graphql-client-factory';
import { SeriesSearchDocument, SeriesSearchQuery } from 'lib/services/queries/SeriasSearch.graphql';
import {
  ArticleSearchSeriesDocument,
  ArticleSearchSeriesQueryVariables,
} from 'lib/services/queries/SeriesArticles.graphql';

class SeriesArticlesService {
  constructor(private readonly graphQLClient: GraphQLRequestClient) {}

  public async getSeriesArticles(language, siteId, seriesId) {
    const seriesArticles = await this.graphQLClient.request<ArticleSearchSeriesQueryVariables>(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ArticleSearchSeriesDocument as any,
      {
        siteId,
        language,
        seriesId: seriesId.toUpperCase(),
        pageSize: 100,
      }
    );

    return seriesArticles?.search.results;
  }

  public async getSeriesBanner(language, seriesName) {
    const queryParams = {
      pageSize: 1,
      pageHash: '',
      seriesName,
      language,
    };
    const seriesSearch = await this.graphQLClient.request<SeriesSearchQuery>(
      SeriesSearchDocument,
      queryParams
    );

    return seriesSearch?.search.results[0];
  }
}

export const seriesArticlesService = new SeriesArticlesService(graphqlClientFactory());
